import React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Skeleton from "@mui/joy/Skeleton";

const CardModalSkeleton = () => {
  return (
    <Card
      variant="outlined"
      orientation="horizontal"
      className="w-full hover:shadow-md hover:border-neutral-outlinedHoverBorder cursor-pointer"
    >
      <AspectRatio ratio="1" className="w-12">
        <Skeleton variant="overlay">
          <img src="" loading="lazy" alt="logo del evento" />
        </Skeleton>
      </AspectRatio>
      <CardContent className="flex items-center">
        <Typography
          level="title-lg"
          id="card-description"
          className="text-base sm:text-lg"
        >
          <Skeleton>""</Skeleton>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardModalSkeleton;
